export default {
    PAY: "Pay",
    CARD_ATTACHMENT_EVOCA: "Card attachment: EVOCA",
    CARD_ATTACHMENT_AMERIA: "Card attachment: AMERIA",
    DEPOSIT_ATTACHED_CARD_EVOCA: " Deposit attached: EVOCA",
    DEPOSIT_ATTACHED_CARD_AMERIA: "Deposit attached: AMERIA",
    DEPOSIT_CARD_EVOCA: "Deposit card: EVOCA",
    DEPOSIT_CARD_AMERIA: "Deposit card: AMERIA",
    DEPOSIT_IDRAM: "Deposit: IDram",
    DEPOSIT_TELCELL: "Deposit: TellCell",
    WITHDRAWAL_LOCAL: "Withdrawal local",
    DEPOSIT_LOCAL: "Deposit local"
};



// WEBPACK FOOTER //
// ./src/data/transaction-types.js